import { ApiError } from '@/api/client';
export function cleanupStatus(_service) {
    const blocksDeletion = _service.cleanup_required === null &&
        _service.is_active &&
        _service.use_rabbitmq &&
        _service.rabbitmq_url.trim().length > 0;
    if (_service.cleanup_required === true) {
        return { label: 'Участвует', tone: 'ok', blocksDeletion };
    }
    if (_service.cleanup_required === false) {
        return { label: 'Не участвует', tone: 'paused', blocksDeletion };
    }
    return {
        label: 'Не настроено',
        tone: blocksDeletion ? 'warn' : 'paused',
        blocksDeletion,
    };
}
export function normalizeCleanup(fields) {
    if (fields.cleanup_required !== true) {
        return {
            cleanup_required: fields.cleanup_required,
            cleanup_contract_version: null,
            cleanup_coordinator_slug: null,
        };
    }
    return {
        cleanup_required: true,
        cleanup_contract_version: fields.cleanup_contract_version,
        cleanup_coordinator_slug: fields.cleanup_coordinator_slug,
    };
}
export function cleanupPatch(original, next) {
    const patch = {};
    for (const key of [
        'cleanup_required',
        'cleanup_contract_version',
        'cleanup_coordinator_slug',
    ]) {
        if (original[key] !== next[key])
            patch[key] = next[key];
    }
    return patch;
}
export function validateCleanup(draft, services, ownSlug, ownConnection) {
    if (draft.cleanup_required !== true)
        return {};
    const errors = {};
    if (draft.cleanup_contract_version !== 1) {
        errors.cleanup_contract_version = 'Выберите версию протокола';
    }
    if (!draft.cleanup_coordinator_slug) {
        errors.cleanup_coordinator_slug = 'Выберите координатора';
        return errors;
    }
    if (draft.cleanup_coordinator_slug.length > 50) {
        errors.cleanup_coordinator_slug = 'Slug координатора должен быть не длиннее 50 символов';
        return errors;
    }
    const coordinator = services.find((item) => item.slug === draft.cleanup_coordinator_slug);
    const isSelf = draft.cleanup_coordinator_slug === ownSlug && ownConnection;
    const candidate = isSelf
        ? {
            slug: ownSlug,
            ...ownConnection,
            ...draft,
        }
        : coordinator;
    if (!candidate) {
        errors.cleanup_coordinator_slug = 'Выбранный координатор не зарегистрирован';
    }
    else if (!candidate.is_active) {
        errors.cleanup_coordinator_slug = 'Координатор должен быть активен';
    }
    else if (!candidate.use_rabbitmq || !candidate.rabbitmq_url.trim()) {
        errors.cleanup_coordinator_slug = 'Координатор должен быть подключён к RabbitMQ';
    }
    else if (candidate.cleanup_contract_version !== 1) {
        errors.cleanup_coordinator_slug = 'У координатора должна быть версия протокола 1';
    }
    else if (candidate.cleanup_required !== true) {
        errors.cleanup_coordinator_slug = 'Координатор должен участвовать в удалении';
    }
    else if (candidate.cleanup_coordinator_slug !== candidate.slug) {
        errors.cleanup_coordinator_slug = 'Координатор должен указывать сам на себя';
    }
    return errors;
}
export function referencedBy(services, slug) {
    return services.filter((service) => service.slug !== slug && service.cleanup_coordinator_slug === slug);
}
export function serviceError(error) {
    if (!(error instanceof ApiError)) {
        return { message: 'Не удалось выполнить запрос', fields: {} };
    }
    if (error.status === 403)
        return { message: 'Недостаточно прав', fields: {} };
    if (error.status === 404)
        return { message: 'Сервис не найден', fields: {} };
    if (error.status === 409) {
        return { message: 'Сервис с таким slug уже существует', fields: {} };
    }
    const detail = error.body?.detail;
    if (error.status === 422 && Array.isArray(detail)) {
        const fields = {};
        for (const item of detail) {
            if (!item || typeof item !== 'object')
                continue;
            const loc = item.loc;
            const msg = item.msg;
            if (!Array.isArray(loc) || typeof msg !== 'string')
                continue;
            const field = [...loc].reverse().find((part) => typeof part === 'string');
            if (typeof field === 'string')
                fields[field] = msg;
        }
        return {
            message: Object.keys(fields).length ? 'Проверьте выделенные поля' : 'Проверьте данные формы',
            fields,
        };
    }
    if (typeof detail === 'string' && detail.trim()) {
        return { message: detail, fields: {} };
    }
    return { message: `Ошибка ${error.status}`, fields: {} };
}
